import { render } from "./InputBistro.vue?vue&type=template&id=98ca1f2c"
import script from "./InputBistro.vue?vue&type=script&lang=js"
export * from "./InputBistro.vue?vue&type=script&lang=js"

import "./InputBistro.vue?vue&type=style&index=0&id=98ca1f2c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__